module.exports = __webpack_public_path__ + "img/p15.db0a8178.png";